/* @ngInject */
function ApprovalStatusController ($scope, $translate) {
  const api = {}
  this.getApi = () => api

  activate()
  function activate () {}

  $scope.getLabelText = (type) => {
    const types = {
      PENDING: $translate.instant('pending'),
      ADJUST: $translate.instant('adjustments'),
      REJECTED: $translate.instant('reproved'),
      APPROVED: $translate.instant('approved'),
      DEFAULT: ''
    }

    if (types[String(type)]) return types[String(type)]

    return types.DEFAULT
  }
}

export { ApprovalStatusController }
